import { styled } from 'styled-components';

import { device } from '@/styles/helpers';

interface SliderContainerProps {
  isFullScreen: boolean;
  paginationInset?: string;
}

export const ScSliderContainer = styled.div<SliderContainerProps>`
  position: relative;
  overflow: ${({ isFullScreen }) => (isFullScreen ? 'visible' : 'hidden')};
  z-index: 3;
  transition: height 0.3s ease-out;

  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 40px 28px;
    position: absolute;
    inset: ${({ paginationInset }) =>
      paginationInset ? paginationInset : 'auto auto 0 0'};
    width: 100%;
    z-index: 1;

    @media (${device.mobile}) {
      padding: 12px 40px 36px;
    }
  }

  .pagination-bullet {
    width: 100%;
    max-width: 48px;
    padding: 4px;
    cursor: pointer;

    &:before {
      position: relative;
      content: '';
      width: 100%;
      height: 4px;
      display: block;
      background: ${({ theme }) => theme.whiteColor};
      opacity: 0.2;
      border-radius: 20px;
      transition: 0.2s;
    }

    @media (${device.mobile}) {
      max-width: 80px;
    }

    &:hover {
      &:before {
        opacity: 0.3;
      }
    }

    &.active,
    &.active:hover {
      &:before {
        opacity: 1;
      }
    }
  }
`;
